$(document).ready(function() {
if ($('html').attr('lang') === 'en') {
        $('#shopify-block-forms_inline_AQegUg').hide();
    } else if ($('html').attr('lang') === 'fr') {
        $('#shopify-block-forms_inline_h8bdRm').hide();
    }
});

// ===========================================================================



// -----------------------2ND STEP----------------------

document.addEventListener("DOMContentLoaded", () => {
  

  document.addEventListener('click', function onceInit(e) {
    const button = e.target.closest('.add-to-cart-gift');
    if (!button) return; 

    const giftVariantId = button.dataset.id; 
    // alert(giftVariantId);

      // Find hidden input
      const input = document.querySelector('.selected__id');
      if (input) {
        input.value = ""; // clear previous value
        input.value = giftVariantId; // set new value
      }

      // Also update sessionStorage
      sessionStorage.removeItem("selectedGiftVariantId"); // clear old
      sessionStorage.setItem("selectedGiftVariantId", giftVariantId);

      // let giftVariantId = null;
let maxSelection = 0;

if (giftVariantId === "52100146561324") {
  maxSelection = 2;
} else if (giftVariantId === "52100174381356") {
  maxSelection = 3;
} else if (giftVariantId === "52100182278444") {
  maxSelection = 4;
} else {
  maxSelection = 6;
}
// Update the total count span with the max selection
const totalCountElement = document.getElementById("totalcount");
if (totalCountElement) {
  totalCountElement.textContent = maxSelection;
}
  const selectedProducts = new Set(); // Store selected product IDs

//  const maxSelection = 4;

  // Helper function to update product count and button states
  const updateSelectionState = () => {
    // Disable or enable buttons based on selection count
    document.querySelectorAll(".select-product[data-action='add']").forEach(btn => {
      const productId = btn.getAttribute("data-product-id");
      btn.disabled = selectedProducts.size >= maxSelection && !selectedProducts.has(productId);
    });

    // Enable or disable "Add to Cart" buttons
    document.getElementById("add-to-cart-btn").disabled = selectedProducts.size < maxSelection;
    document.getElementById("add-this-cart-btn").disabled = selectedProducts.size < maxSelection;

    // Update the selected count in the span
  const countElement = document.getElementById("selectcount");
  if (countElement) {
    countElement.textContent = selectedProducts.size;
  }

  // Update the total count span with the max selection
const totalCountElement = document.getElementById("totalcount");
if (totalCountElement) {
  totalCountElement.textContent = maxSelection;
}

    // Add or remove 'activee' class based on selection count
    const twoStepElement = document.querySelector("#twostep");
    const oneStepElement = document.querySelector("#onestep");
    if (selectedProducts.size === maxSelection) {
      if (twoStepElement) {
        twoStepElement.classList.add("activee");
        oneStepElement.classList.add("show-note");
        
      }

      // Scroll to the third step after 4 products are selected
      const thirdStepElement = document.querySelector("#thirdcheck");
      if (thirdStepElement) {

        
        const offset = 150;
        const topPosition = thirdStepElement.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({
          top: topPosition,
          behavior: "smooth"
        });
;

      }
    } else {
      if (twoStepElement) {
        twoStepElement.classList.remove("activee");
      }
    }

    // Loop through all product li elements
    document.querySelectorAll(".tag__product").forEach(productElement => {
      const variantId = productElement.getAttribute("data-variant-id");

      if (selectedProducts.size >= maxSelection) {
        // Add 'greyed' to non-selected products
        if (!selectedProducts.has(variantId)) {
          productElement.classList.add("greyed");
          productElement.classList.remove("notgreyed");
        }
      } else {
        // Remove 'greyed' and 'notgreyed' from all products
        productElement.classList.remove("greyed", "notgreyed");
      }

      // Add 'notgreyed' class to selected products
      if (selectedProducts.has(variantId)) {
        productElement.classList.add("notgreyed");
        productElement.classList.remove("greyed");
      }
    });
  };

  // Event listener for "+" and "-" buttons
  document.querySelectorAll(".select-product").forEach(button => {
    button.addEventListener("click", () => {
      const action = button.getAttribute("data-action");
      const productId = button.getAttribute("data-product-id");
      const quantitySpan = document.querySelector(`.product-quantity[data-product-id="${productId}"]`);

      let quantity = parseInt(quantitySpan.textContent);

      if (action === "add") {
        if (selectedProducts.size < maxSelection && !selectedProducts.has(productId)) {
          selectedProducts.add(productId);
          quantity = 1;
        }
      } else if (action === "remove") {
        if (selectedProducts.has(productId)) {
          selectedProducts.delete(productId);
          quantity = 0;
        }
      }

      quantitySpan.textContent = quantity;
      updateSelectionState();
    });
  });


  // Event listener for "Add Selected Products to Cart" buttons
  const handleAddToCart = (isThisCart = false) => {
    const uniqueBundleId = `bundle_${Date.now()}`;
    
let bundleProperties = null;
  
const items = [];

// let giftVariantId = parseInt(button.dataset.id, 10);

if (giftVariantId === "52100184801580") {
 bundleProperties = {
      bundle_id: uniqueBundleId,
      note: "Custom bundle",
      gift: "6-Pack Gift Box"
    };

    items.push(
      {
      id: giftVariantId,
      quantity: 1,
      properties: bundleProperties
    },
      {
       id: '52100206625068',
      quantity: 1,
      properties: bundleProperties
   }
  )
}
else if (giftVariantId === "52100182278444") {
 bundleProperties = {
      bundle_id: uniqueBundleId,
      note: "Custom bundle",
      gift: "4-Pack Gift Box"
    };

    items.push(
      {
      id: giftVariantId,
      quantity: 1,
      properties: bundleProperties
    },
      {
       id: '52100206625068',
      quantity: 1,
      properties: bundleProperties
      
   }
  )
}

else if (giftVariantId === "52100174381356") {
 bundleProperties = {
      bundle_id: uniqueBundleId,
      note: "Custom bundle",
      gift: "3-Pack Gift Box"
    };

     items.push(
      {
      id: giftVariantId,
      quantity: 1,
      properties: bundleProperties,
    }
  );
}
  else{
    bundleProperties = {
      bundle_id: uniqueBundleId,
      note: "Custom bundle",
      gift: "2-Pack Gift Box"
    };

     items.push(
      {
      id: parseInt(giftVariantId, 10),
      quantity: 1,
      properties: bundleProperties
    }
  );
  }

    // Add selected products to the items array
    items.push(
      ...Array.from(selectedProducts).map(id => ({
        id: parseInt(id, 10),
        quantity: 1,
        properties: bundleProperties
      }))
    );

    if (items.length > 0) {

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      })
        .then(response => response.json())
        .then(data => {
          if (data.errors) {
           console.log("Payload:", JSON.stringify({ items }, null, 2));

          } else {
            // alert( "Products added to the cart successfully!" + JSON.(items, null, 8) );
     
if (isThisCart) {
  // Ensure the DOM elements exist before attempting to add the classes
  const thirdStepElement = document.getElementById('thrdstep');
  const twoStepElement = document.getElementById('twostep');

  if (thirdStepElement) {
    thirdStepElement.classList.add('active-third'); // Add class
  } else {
    // console.error('Element with id "thrdstep" not found in the DOM.');
  }

  if (twoStepElement) {
    twoStepElement.classList.add('activee'); // Add class
  } else {
    // console.error('Element with id "twostep" not found in the DOM.');
  }

const currentPath = window.location.pathname;

if (currentPath === "/collections/custom-gift") {
  setTimeout(() => {
    window.location.href = "/collections/custom-gift";
  }, 2000);
} else if (currentPath === "/fr/collections/custom-gift") {
  setTimeout(() => {
    window.location.href = "/fr/collections/custom-gift";
  }, 2000);
}


}           
            
else {
  // Ensure the DOM elements exist before attempting to add the classes
  const thirdStepElement = document.getElementById('thrdstep');
  const twoStepElement = document.getElementById('twostep');

  if (thirdStepElement) {
    thirdStepElement.classList.add('active-third');
  } else {
    // console.error('Element with id "thrdstep" not found in the DOM.');
  }

  if (twoStepElement) {
    twoStepElement.classList.add('activee');
  } else {
    // console.error('Element with id "twostep" not found in the DOM.');
  }

// Get only the path after domain
const currentPath = window.location.pathname;

// Check the path and redirect accordingly
if (currentPath.startsWith("/collections/custom-gift")) {
  setTimeout(() => {
    window.location.href = "/cart";
  }, 2000);
} else if (currentPath.startsWith("/fr/collections/custom-gift")) {
  setTimeout(() => {
    window.location.href = "/fr/cart";
  }, 2000);
}
else {
  setTimeout(() => {
    window.location.href = "/cart";
  }, 2000);
}
  
}
          }
        })
        .catch(error => {
          // alert("An error occurred. Please try again.");
        });
    } else {
      // alert("No products selected to add to the cart.");
    }
  };

  document.getElementById("add-to-cart-btn").addEventListener("click", () => handleAddToCart());
  document.getElementById("add-this-cart-btn").addEventListener("click", () => handleAddToCart(true));

  // Event delegation for "cartcheck" and "cartadd"
  document.getElementById("cartcheck").addEventListener("click", () => {
    document.getElementById("add-to-cart-btn").click();
  });

  document.getElementById("cartadd").addEventListener("click", () => {
    document.getElementById("add-this-cart-btn").click();
  });


  // =============select all button trigger starts====================

  
document.body.addEventListener('click', function (event) {
  if (event.target.matches('.all-addtocart')) {
    // Trigger an alert when the button is clicked
    // alert('Button clicked!');

    // Get all products inside `.thisfour-actions` up to the maxSelection limit
    const allProductButtons = document.querySelectorAll('.thisfour-actions .select-product[data-action="add"]');
    const selectedButtons = Array.from(allProductButtons).slice(0, maxSelection);

    selectedButtons.forEach((button) => {
      const productId = button.getAttribute('data-product-id');
      if (!selectedProducts.has(productId) && selectedProducts.size < maxSelection) {
        // Add the product ID to the selectedProducts set
        selectedProducts.add(productId);

        // Update the quantity span
        const quantitySpan = document.querySelector(`.thisfour-actions .product-quantity[data-product-id="${productId}"]`);
        if (quantitySpan) {
          quantitySpan.textContent = '1';
        }
      }
    });

    // Update the UI state
    updateSelectionState();
  }
});
  
});


// ------------------backfriday filters--------------


  const selectedTagsDiv = document.querySelector('.selected_tag');
  const clearAllButton = selectedTagsDiv.querySelector('.clear-all');
  const allAddToCartButton = document.createElement('button');
  const allAddToCartline = document.createElement('p');
  allAddToCartButton.classList.add('all-addtocart');
  allAddToCartline.classList.add('all-cart-info');
  allAddToCartButton.textContent = 'Select All';
  allAddToCartline.textContent = 'Click to select the blends below and move to the next step.';
  allAddToCartButton.style.display = 'none'; // Initially hidden
  allAddToCartline.style.display = 'none'; // Initially hidden
  selectedTagsDiv.appendChild(allAddToCartButton); // Append button to the selected tags div
  selectedTagsDiv.appendChild(allAddToCartline); // Append button to the selected tags div


  // Function to get an array of selected tag values in lowercase
  function getSelectedTags() {
    const selectedTags = [];
    selectedTagsDiv.querySelectorAll('.tag').forEach(tag => {
      selectedTags.push(tag.getAttribute('data-tag').toLowerCase());
    });
    return selectedTags;
  }

  // Function to process all `.tag__product` elements
  function updateProductClasses() {
    const giftVariantId = sessionStorage.getItem("selectedGiftVariantId");

let maxSelection = 0;

if (giftVariantId === "52100146561324") {
  maxSelection = 2;
} else if (giftVariantId === "52100174381356") {
  maxSelection = 3;
} else if (giftVariantId === "52100182278444") {
  maxSelection = 4;
} else {
  maxSelection = 6;
}

    const selectedTagsArray = getSelectedTags();
    // console.log('Selected tags:', selectedTagsArray);

    // // Toggle visibility of "All add to cart" button
    // if (selectedTagsArray.length === 1 && selectedTagsArray.some(tag => tag.includes('top'))) {
    //   allAddToCartButton.style.display = 'block';
    //    allAddToCartline.style.display = 'block';
    // } else {
    //   allAddToCartButton.style.display = 'none';
    //   allAddToCartline.style.display = 'none';
    // }

    // If no tags are selected, remove the `notmatched` and `thisfour` classes from all products
    if (selectedTagsArray.length === 0) {
      document.querySelectorAll('.tag__product').forEach(product => {
        product.classList.remove('notmatched');
        product.classList.remove('matched-tag');
        product.classList.remove('thisfour'); // Remove 'thisfour' if no tags selected
        const productActions = product.querySelector('.product-actions');
        if (productActions) {
          productActions.classList.remove('thisfour-actions'); // Remove 'thisfour-actions' if no match
        }
      });
      return;
    }

    let matchedCount = 0; // Counter for the first four matched products with 'top'

    // Iterate through each `.tag__product` and check for matches
    document.querySelectorAll('.tag__product').forEach(product => {
      const dynamicTagsArray = product
        .getAttribute('data-tags')
        .split(',')
        .map(tag => tag.trim().toLowerCase());

      // console.log('Dynamic data-tags:', dynamicTagsArray);

      // Check if any of the selected tags match the product's tags
      const hasMatchingTag = selectedTagsArray.some(tag => dynamicTagsArray.includes(tag));

// ----------------------------------------------------------------------------------------------------------------------
  // const maxSelection = 4;
// --------------------------------------------------------------------------------------------

      if (hasMatchingTag) {
        product.classList.add('matched-tag');
        product.classList.remove('notmatched');

        
        // Add 'thisfour' class if conditions are met
        if (selectedTagsArray.length === 1 && selectedTagsArray.some(tag => tag.includes('top')) && matchedCount < maxSelection) {
          product.classList.add('thisfour');
          matchedCount++; // Increment the counter after adding 'thisfour'
          
          // Add class to the inner '.product-actions' div
          const productActions = product.querySelector('.product-actions');
          if (productActions) {
            productActions.classList.add('thisfour-actions');
          }
        } else {
          product.classList.remove('thisfour'); // Ensure 'thisfour' is removed if conditions are not met
          
          // Remove class from the inner '.product-actions' div
          const productActions = product.querySelector('.product-actions');
          if (productActions) {
            productActions.classList.remove('thisfour-actions');
          }
        }
      } else {
        product.classList.remove('matched-tag');
        product.classList.add('notmatched');
        product.classList.remove('thisfour'); // Remove 'thisfour' if no match
        
        // Remove class from the inner '.product-actions' div
        const productActions = product.querySelector('.product-actions');
        if (productActions) {
          productActions.classList.remove('thisfour-actions');
        }
      }
    });
  }

  // Event listener for tag filters
  document.querySelectorAll('.tag-filters__item').forEach(tag => {
    
    tag.addEventListener('click', function () {
      const giftVariantId = sessionStorage.getItem("selectedGiftVariantId");

let maxSelection = 0;

if (giftVariantId === "52100146561324") {
  maxSelection = 2;
} else if (giftVariantId === "52100174381356") {
  maxSelection = 3;
} else if (giftVariantId === "52100182278444") {
  maxSelection = 4;
} else {
  maxSelection = 6;
}

      const tagName = this.getAttribute('data-tag');

      // Avoid adding duplicate tags
      if (!document.querySelector(`.selected_tag .tag[data-tag="${tagName}"]`)) {
        const formattedTagName = tagName.replace(/_/g, ' ').replace(/-/g, ' ');

        const tagElement = document.createElement('div');
        tagElement.classList.add('tag');
        tagElement.setAttribute('data-tag', tagName);
        tagElement.innerHTML = `
          <span>${formattedTagName}</span>
          <button class="crosss" aria-label="Remove tag">x</button>
        `;
        selectedTagsDiv.insertBefore(tagElement, clearAllButton);
        clearAllButton.style.display = 'inline-block';

        // Add click event to remove the tag
        tagElement.querySelector('.crosss').addEventListener('click', function () {
          tagElement.remove();
          if (selectedTagsDiv.querySelectorAll('.tag').length === 0) {
            clearAllButton.style.display = 'none';
          }
          updateProductClasses();
        });
      }

      updateProductClasses();
    });
  });

  // Clear All functionality
  clearAllButton.addEventListener('click', function () {
    selectedTagsDiv.querySelectorAll('.tag').forEach(tag => tag.remove());
    clearAllButton.style.display = 'none';
    updateProductClasses();
  });

}, { capture: true, once: true });




// ------------------------autoscroll-------------------

document.addEventListener("DOMContentLoaded", () => {
  const stickyBundleBar = document.querySelector("#stickybundlebar");
  const stickyClass = "sticky-active"; // Class to be toggled on scroll
  const scrollThreshold = 1; // Scroll distance (in pixels) to trigger the class addition

  if (!stickyBundleBar) {
    // console.error("Element with ID 'stickybundlebar' not found.");
    return;
  }

  // Remove the class initially
  stickyBundleBar.classList.remove(stickyClass);

  // Add scroll event listener
  window.addEventListener("scroll", () => {
    if (window.scrollY > scrollThreshold) {
      if (!stickyBundleBar.classList.contains(stickyClass)) {
        stickyBundleBar.classList.add(stickyClass);
        // console.log(`Class '${stickyClass}' added to #stickybundlebar.`);
      }
    } else {
      if (stickyBundleBar.classList.contains(stickyClass)) {
        stickyBundleBar.classList.remove(stickyClass);
        // console.log(`Class '${stickyClass}' removed from #stickybundlebar.`);
      }
    }
  });
});


// ----------------------------------Progress bar----------------------

const addToCartGiftButtons = document.querySelectorAll('.add-to-cart-gift');

if (addToCartGiftButtons.length > 0) {
  addToCartGiftButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const giftVariantId = button.getAttribute("data-id"); // get clicked product ID

      // --- Existing functionality ---
      const note = document.querySelector('#onestep');
      const pickSection = document.querySelector('#picksection');

      if (note) {
        // Remove then add class (re-trigger animation)
        note.classList.remove('show-note');
        note.classList.add('show-note');
      }

      // Smooth scroll to pick section with offset
      if (pickSection) {
        const offset = 150; // adjust as needed
        const topPosition = pickSection.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top: topPosition,
          behavior: 'smooth'
        });
      }
    });
  });
}


// =================scroll upto Step2=====================

const backStepButton = document.querySelector('.back_step');

if (backStepButton) {
    backStepButton.addEventListener('click', function() {
   

    // Remove the 'activee' class from the #twostep element
    document.querySelector('#twostep').classList.remove('activee');

    // Scroll to the #picksection element with an offset of -150px
    const pickSection = document.querySelector('#picksection');
    if (pickSection) {
        const offsetTop = pickSection.getBoundingClientRect().top + window.scrollY - 150;
        window.scrollTo({
            top: offsetTop,
            behavior: 'smooth' // Smooth scrolling effect
        });
    }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    const discountCode = getCookie('discount_code'); // Replace with the actual cookie name
    const couponSpan = document.querySelector('.dynamic_coupancode');
    const discountReferral = document.querySelector('.discount_referal');

    if (discountCode) {
        if (couponSpan) {
            couponSpan.textContent = discountCode;
        }
        if (discountReferral) {
            discountReferral.style.display = 'block';
        }
    } else if (discountReferral) {
        discountReferral.style.display = 'none';
    }
});



// ==============DISPLAY ONE LOGIN MESSAGE================

  document.addEventListener("DOMContentLoaded", function () {
  const orderSections = document.querySelectorAll(".orders_login");
  let firstFound = false;

  orderSections.forEach((section) => {
    const orderRegDiv = section.querySelector(".order_registeration");
    
    if (orderRegDiv) {
      if (firstFound) {
        section.style.display = "none";
      } else {
        firstFound = true;
      }
    }
  });
});